<ngx-avatars
  class="avatar"
  [style]="customAvatarStyle"
  [size]="size"
  [src]="user?.profilePictureUrl?.length ? user?.profilePictureUrl : 'assets/media/vescent/userpic.svg'"
  (clickOnAvatar)="clickOnAvatar()"
>
        
</ngx-avatars>

<img 
  class="avatar-custom-icon" 
  *ngIf="icon" 
  src="{{ icon | iconByName }}"
  [width]="size/1.5" 
    [height]="size/1.5"
/>